<!--AFFICHAGE BLOC DIRIGEANTS -->
<template>
  <v-col md="12" class="pa-3 d-flex flex-column" v-if="this.condition()" >
          <a class="anchor" id="blocevenements"></a>

    <v-card elevation="2">
      <v-card-title>
        <v-icon dense left color="blue">mdi-bullhorn</v-icon>
        Evènements et annonces légales
      </v-card-title>

      <v-card-subtitle>Annonces BODACC</v-card-subtitle>
        <v-data-table
            v-if="bodacc"
            dense
            :headers="headersBodacc"
            :items="bodacc"
            item-key="id"

            single-expand
            :expanded.sync="expandedbodacc"
            show-expand
        >
            <template v-slot:item.alerte="{ item }">
            <v-icon v-if="item.alerte" color="red">
              mdi-alert-circle
            </v-icon>
          </template>
           <template v-slot:item.titre="{ item }">
             <a v-bind:href="'https://www.bodacc.fr/pages/annonces-commerciales-detail/?q.id=id:'+item.identifiant" target="_blank">{{item.typeavis_lib}} - {{item.familleavis_lib}}</a><br/>
             <b>{{item.titre}}</b><br/>
             <i>Annonce  Bodacc n° {{item.identifiant}} publiée le {{item.dateparution}} au {{item.tribunal}} :</i><br/>
             {{ item.annonce }}
          </template>

          https://www.bodacc.fr/pages/annonces-commerciales-detail/?q.id=id:B20210179519

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <p v-if="item.jugement">
                jugement

              </p>
              <br/>
              <h7>Liste des personnes concernées par l'annonce</h7>
              <br/>
              <br/>
              <v-data-table
                  v-if="item.listepersonnes"
                  dense
                   hide-default-footer
                  :headers="headersPersonne"
                  :items="item.listepersonnes"
                  class="elevation-1"
              >
               <template v-slot:item.name="{ item }">
                    {{ item.nom }} {{ item.prenom }} {{ item.denomination }}
                </template>
                <template v-slot:item.immat="{ item }">
                    {{ item.numeroImmatriculation.numeroIdentification }} {{ item.numeroImmatriculation.codeRCS }} {{ item.numeroImmatriculation.nomGreffeImmat }}
                </template>
                <template v-slot:item.adressepersonne="{ item }" >
                  <p v-if="item.adresseSiegeSocial">
                  {{ item.adresseSiegeSocial.complGeographique}} {{ item.adresseSiegeSocial.numeroVoie}} {{ item.adresseSiegeSocial.typeVoie}} {{ item.adresseSiegeSocial.nomVoie}}, {{ item.adresseSiegeSocial.codePostal}} {{ item.adresseSiegeSocial.ville}}, {{ item.adresseSiegeSocial.pays}}
                 </p>
                 <p v-if="item.adresse">
                  {{ item.adresse.complGeographique}} {{ item.adresse.numeroVoie}} {{ item.adresse.typeVoie}} {{ item.adresse.nomVoie}}, {{ item.adresse.codePostal}} {{ item.adresse.ville}}, {{ item.adresse.pays}}
                  </p>
                </template>
                <template v-slot:item.capitalsocial="{ item }">
                  <p v-if="item.capital">
                    {{ item.capital.montantCapital }} {{ item.capital.devise }}
                  </p>
                </template>
              </v-data-table>
              <br/>
              <h7 v-if="item.listeprecedentproprietaire">Liste des précédents proprietaires</h7>
              <br/><br/>
              <v-data-table
                  v-if="item.listeprecedentproprietaire"
                  dense
                   hide-default-footer
                  :headers="headersPersonne"
                  :items="item.listeprecedentproprietaire"
                  class="elevation-1"
              >
                 <template v-slot:item.name="{ item }">
                    {{ item.nom }} {{ item.prenom }} {{ item.denomination }}
                </template>
                <template v-slot:item.immat="{ item }">
                    {{ item.numeroImmatriculation.numeroIdentification }} {{ item.numeroImmatriculation.codeRCS }} {{ item.numeroImmatriculation.nomGreffeImmat }}
                </template>
                <template v-slot:item.adressepersonne="{ item }" >
                  <p v-if="item.adresseSiegeSocial">
                  {{ item.adresseSiegeSocial.complGeographique}} {{ item.adresseSiegeSocial.numeroVoie}} {{ item.adresseSiegeSocial.typeVoie}} {{ item.adresseSiegeSocial.nomVoie}}, {{ item.adresseSiegeSocial.codePostal}} {{ item.adresseSiegeSocial.ville}}, {{ item.adresseSiegeSocial.pays}}
                 </p>
                 <p v-if="item.adresse">
                  {{ item.adresse.complGeographique}} {{ item.adresse.numeroVoie}} {{ item.adresse.typeVoie}} {{ item.adresse.nomVoie}}, {{ item.adresse.codePostal}} {{ item.adresse.ville}}, {{ item.adresse.pays}}
                  </p>

                </template>
                <template v-slot:item.capitalsocial="{ item }">
                  <p v-if="item.capital">
                    {{ item.capital.montantCapital }} {{ item.capital.devise }}
                  </p>
                </template>
              </v-data-table>
              <br/>
               <h7 v-if="item.listeprecedentexploitant">Liste des précédents exploitants</h7>
              <br/>
              <br/>
              <v-data-table
                  v-if="item.listeprecedentexploitant"
                  dense
                   hide-default-footer
                  :headers="headersPersonne"
                  :items="item.listeprecedentexploitant"
                  class="elevation-1"
              >
                <template v-slot:item.name="{ item }">
                    {{ item.nom }} {{ item.prenom }} {{ item.denomination }}
                </template>
                <template v-slot:item.immat="{ item }">
                    {{ item.numeroImmatriculation.numeroIdentification }} {{ item.numeroImmatriculation.codeRCS }} {{ item.numeroImmatriculation.nomGreffeImmat }}
                </template>
               <template v-slot:item.adressepersonne="{ item }" >
                  <p v-if="item.adresseSiegeSocial">
                  {{ item.adresseSiegeSocial.complGeographique}} {{ item.adresseSiegeSocial.numeroVoie}} {{ item.adresseSiegeSocial.typeVoie}} {{ item.adresseSiegeSocial.nomVoie}}, {{ item.adresseSiegeSocial.codePostal}} {{ item.adresseSiegeSocial.ville}}, {{ item.adresseSiegeSocial.pays}}
                 </p>
                 <p v-if="item.adresse">
                  {{ item.adresse.complGeographique}} {{ item.adresse.numeroVoie}} {{ item.adresse.typeVoie}} {{ item.adresse.nomVoie}}, {{ item.adresse.codePostal}} {{ item.adresse.ville}}, {{ item.adresse.pays}}
                  </p>

                </template>
                <template v-slot:item.capitalsocial="{ item }">
                  <p v-if="item.capital">
                    {{ item.capital.montantCapital }} {{ item.capital.devise }}
                  </p>
                </template>

                <br/>

                </v-data-table>
             <h7 v-if="item.listeetablissements">Liste etablissements concernées</h7>
              <br/>
              <br/>
              <v-data-table
                  v-if="item.listeetablissements"
                  dense
                   hide-default-footer
                  :headers="headersEtabs"
                  :items="item.listeetablissements"
                  class="elevation-1"
              >
              <template v-slot:item.adresseetab="{ item }" >
                  <p v-if="item.adresse">
                  {{ item.adresse.complGeographique}} {{ item.adresse.numeroVoie}} {{ item.adresse.typeVoie}} {{ item.adresse.nomVoie}}, {{ item.adresse.codePostal}} {{ item.adresse.ville}}, {{ item.adresse.pays}}
                  </p>

                </template>
              </v-data-table>
              <br/>
            </td>
          </template>
        </v-data-table>


      <v-card-text>
        <v-card-subtitle v-if="evenements">Evènements Info Legale</v-card-subtitle>
        <v-data-table
            v-if="evenements"
            dense
            :headers="headers"
            :items="evenements"
            item-key="adId"
            class="elevation-1"
        >
          <template v-slot:item.impact="{ item }">
            <v-chip v-if="item.impact" :color="getColor(item.impact)" dark>
              !
            </v-chip>
          </template>
        </v-data-table>
        <v-spacer></v-spacer>
        <v-card-subtitle>Evènements Actu Legales</v-card-subtitle>
        <v-data-table
            v-if="actulegales"
            dense
            :headers="headersActuLegales"
            :items="actulegales"
            item-key="idx"
            class="elevation-1"
            single-expand
            :expanded.sync="expanded"
            show-expand
        >
            <template v-slot:item.alerte="{ item }">
            <v-icon v-if="item.alerte" color="red">
              mdi-alert-circle
            </v-icon>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              {{ item.annonce }}
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "Identite",
  props: ["etablissement"],
  components: {},
  data() {
    return {
      expanded: [],
      expandedbodacc : []
    }
  },
  computed: {
    evenements: function () {
      return this.$store.getters.getbloc("evenements", "donnees", "events", null, "valeur")
    },
    bodacc: function () {
      return this.$store.getters.getbloc("evenements", "donnees", "bodacc", null, "valeur")
    },
    actulegales: function () {
      return this.$store.getters.getbloc("evenements", "donnees", "liste_des_annonces_legales", null, "valeur")
    },
    headers() {
      return [
        {text: "Impact", value: "impact", align: "start"},
        {text: "Type", value: "categorie", align: "start"},
        {text: "Date d'effet", value: "dateEffet", align: "start"},
        {text: "Date de parution", value: "dateParution", align: "start"},
        {text: "Origine", value: "origine", align: "start"},
      ];
    },
    headersActuLegales() {
      return [
          {text: "Alerte", value: "alerte", align: "start"},
        {text: "Date", value: "date", align: "start"},
        {text: "Titre", value: "titre", align: "start"},
        {text: "Source", value: "source", align: "start"},
        { text: '', value: 'data-table-expand' },
      ];
    },
    headersBodacc() {
      return [
        {text: "Alerte", value: "alerte", align: "start"},
        {text: "Date", value: "dateparution", align: "start"},
        {text: "Titre", value: "titre", align: "start"},
        { text: '', value: 'data-table-expand' },

        //{text: "Annonce", value: "annonce", align: "start"},
      ];
    },
    headersPersonne() {
      return [

        {text: "Type", value: "typePersonne", align: "start"},
        {text: "Immat", value: "immat", align: "start"},
        {text: "Nom", value: "name", align: "start"},
        {text: "Nationalité", value: "nationalite", align: "start"},
        {text: "Administration", value: "administration", align: "start"},
        {text: "Capital", value: "capitalsocial", align: "start"},
        {text: "Activite", value: "activite", align: "start"},
        {text: "Forme Juridique", value: "formeJuridique", align: "start"},
        {text: "Adresse", value: "adressepersonne", align: "start"},


        //{text: "Annonce", value: "annonce", align: "start"},
      ];
    },
     headersEtabs() {
      return [
        {text: "Qualite", value: "qualiteEtablissement", align: "start"},
        {text: "Activite", value: "activite", align: "start"},
        {text: "Origine des Fonds", value: "origineFonds", align: "start"},
        {text: "Adresse", value: "adresseetab", align: "start"},

      ];
    },
  },

  methods: {
    condition() {
      return this.$store.getters.condition("evenements", "donnees");
    },
    getColor(impact) {
      if (impact == "scorer") return "red";
      if (impact == "scoreo") return "orange";
      if (impact == "scoren") return "black";
      else return "";
    },
  },
};
</script>
